<div class="iq-works-box text-left">
  <div class="step">{{ step }}</div>
  <div class="icon-bg text-center">
    <ng-content select="[cardMedia]"></ng-content>
  </div>
  <ng-content select="[cardBody]"></ng-content>
</div>
